import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Sprout, Users, Fingerprint } from 'lucide-react';
import { useScanner } from '../contexts/ScannerContext';
import UserAvatar from './UserAvatar';
import '../styles/BottomNavBar.css';

const BottomNavBar = () => {
  const { openScanner } = useScanner();
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));

  return (
    <nav className="bottom-nav select-none">
      <NavLink 
        to="/dashboard" 
        className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
        aria-label="Home"
      >
        <LayoutDashboard className="bottom-nav-icon" size={24} />
        <span className="bottom-nav-label">Home</span>
      </NavLink>
      
      <NavLink 
        to="/fields" 
        className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
        aria-label="Fields"
      >
        <Sprout className="bottom-nav-icon" size={24} />
        <span className="bottom-nav-label">Fields</span>
      </NavLink>

      <button className="bottom-nav-item scanner-trigger" onClick={openScanner} aria-label="Scan QR">
        <div className="scanner-fab">
          <Fingerprint size={30} />
        </div>
        <span className="bottom-nav-label">Scan</span>
      </button>
      
      <NavLink 
        to="/feed" 
        className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
        aria-label="Feed"
      >
        <Users className="bottom-nav-icon" size={24} />
        <span className="bottom-nav-label">Feed</span>
      </NavLink>

      <NavLink 
        to="/profile" 
        className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
        aria-label="Profile"
      >
        <div className="bottom-nav-icon">
          <UserAvatar user={userInfo} size={24} />
        </div>
        <span className="bottom-nav-label">Me</span>
      </NavLink>
    </nav>
  );
};

export default BottomNavBar;
